import companyService from "reduxStore/service/companyService";
import { COMPANY_EMPLOYEE_LIST, COMPANY_EMPLOYEE_LIST_ERROR, COMPANY_LIST, COMPANY_LIST_ERROR } from "reduxStore/types";
import strings from "translate/language";
import { errorToast, successToast, unAuthorizedError } from "utils/httpClient";


export const getEmployeeList = (item) => async (dispatch) => {
    try {
        // console.log("salma cpid", item)
       const res = await companyService.getEmployeeList(item);
       if (res.data.status === 200) {
        // console.log("res.data.status",res.data?.data)
        dispatch({
            type: COMPANY_EMPLOYEE_LIST,
            payload: res.data?.data,
        });
       } else {
        dispatch({
            type: COMPANY_EMPLOYEE_LIST_ERROR,
            payload: [],
        })
       }
    } catch (e) {
        const { response = strings.initialError } = e;
        errorToast(response.data.message);  
    }
};